exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.address-box__selected[data-v-59888284] {\n    background-color: rgba(0, 0, 0, .08);\n    border: 2px solid #ccc;\n}\n.address-box_un_selected[data-v-59888284] {\n    border: 2px solid #fff;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.hoverIE[data-v-59888284] {\n   width:100%;\n}\n.hoverIE[data-v-59888284]:hover {\n    background-color: lightgray!important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59888284","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contracts/ContractAddressDetails.vue
// module id = BXbK
// module chunks = 1